<template>
  <v-layout row wrap>
    <v-flex xs6 mt-2 v-for="user in users" :key="user.id">
      <v-card class="text-xs-center mx-1" max-width="auto">
        <v-avatar size="90px" class="mt-4">
          <v-img
            :style="`border: 3.2px solid `+ user.color + ';' + `background-color: ${user.color}`"
            :src="user.image"
            aspect-ratio="1.9"
            @click="show_user(user)"
            class="hover"
          ></v-img>
        </v-avatar>
        <v-layout row wrap>
          <v-flex xs12 style="height: 50px;">
            <v-flex xs12
              class="text-xs-center font-weight-bold text-uppercase text-12-security pt-1"
            >{{ user.name }}</v-flex>
            <v-flex xs12
              class="text-xs-center font-weight-bold text-uppercase text-12-security"
            >{{ user.last_name }}</v-flex>
          </v-flex>
          <v-flex
            xs12
            class="text-xs-center pb-1 text-14-security"
            style="line-height: 10px;"
          >{{ user.company }}</v-flex>
          <v-flex xs12 mb-2>
            <v-btn
              flat
              small
              v-bind:href="`mailto:${user.email}`"
              :color="user.color"
              dark
              class="font-weight-bold"
              style="text-transform: none"
            >
              <img v-if="user.color == '#8D0C9A'" class="material-icons p-auto color-purple" style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/handshake-solid.svg" alt="">
              <img v-if="user.color == '#008DCF'" class="material-icons p-auto color-lightblue " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/handshake-solid.svg" alt="">
              <img v-if="user.color == '#FF052B'" class="material-icons p-auto color-red " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/handshake-solid.svg" alt="">
              <img v-if="user.color == '#FF6E00'" class="material-icons p-auto color-orange " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/handshake-solid.svg" alt="">
              <img v-if="user.color == '#628D36'" class="material-icons p-auto color-green " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/handshake-solid.svg" alt="">
              <img v-if="user.color == '#bbb'" class="material-icons p-auto color-default " style="width: 15px; padding-top: 5px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/handshake-solid.svg" alt="">
              <span class="pl-1 caption font-weight-bold">Felicitar</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.user_welcome .v-image__image {
  background-position: center top !important;
}
.greeting {
  font-family: Lato, sans-serif;
  line-height: 12px;
  font-size: 12px;
}
.greeting a {
  text-decoration: none;
  color: black;
}
.link-format a {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  font-family: Lato, sans-serif;
  padding-left: 12px;
}
.link-format:hover {
  text-decoration: underline;
}
.color-purple{
  filter: invert(9%) sepia(94%) saturate(7242%) hue-rotate(294deg) brightness(79%) contrast(112%);
}
.color-lightblue {
  filter: invert(44%) sepia(64%) saturate(6283%) hue-rotate(178deg) brightness(100%) contrast(101%);
}
.color-red {
  filter: invert(13%) sepia(90%) saturate(7315%) hue-rotate(345deg) brightness(104%) contrast(116%);
}
.color-orange {
  filter: invert(41%) sepia(64%) saturate(1560%) hue-rotate(1deg) brightness(104%) contrast(104%);
}
.color-green {
  filter: invert(44%) sepia(59%) saturate(409%) hue-rotate(47deg) brightness(99%) contrast(92%);
}
.color-gris {
  filter: invert(82%) sepia(14%) saturate(0%) hue-rotate(144deg) brightness(89%) contrast(93%);
}
.color-default {
  filter: invert(81%) sepia(10%) saturate(25%) hue-rotate(345deg) brightness(94%) contrast(84%);
}
</style>

<script>
import config from "@/config";
import axios from "axios";
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      users: []
    };
  },
  async mounted() {
    const { data: homeWelcomes } = await axios.get(process.env.VUE_APP_API_URL + "/welcome/get_home_welcome");
    this.users = homeWelcomes

    if (this.$vuetify.breakpoint.smAndDown) {
      this.users = this.users.slice(0, 2)
    }
  },
  methods: {
    ...mapActions("user", ["fetchUser"]),
    show_user(user) {
      this.fetchUser(user.id);
      this.$router.push({
        name: "user-show",
        params: { id: user.id }
      });
    },
    goWelcome() {
      this.$router.push({
        name: "celebremos-bienvenidos"
      });
    }
  }
};
</script>

